exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".fts-listing-design-modal .list-design-error[data-v-661dbb58]{margin-top:.5rem}", ""]);

// exports
